var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide-fade" } }, [
    _c(
      "div",
      {
        staticClass: "notification-request",
        class: { denied: _vm.deniedMode },
        on: {
          click: function ($event) {
            _vm.deniedMode ? _vm.enableNotifications : _vm.$_.noop
          },
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "notification-request-text",
            on: { click: _vm.enableNotifications },
          },
          [
            _vm.deniedMode
              ? _c("i", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.deniedText")) +
                      "\n            "
                  ),
                ])
              : _c("i", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.notificationText")) +
                      "\n            "
                  ),
                ]),
            _vm._v(" "),
            !_vm.deniedMode
              ? _c("button", { staticClass: "notification-request-button" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.enableNotification")) +
                      "\n            "
                  ),
                ])
              : _c(
                  "button",
                  {
                    staticClass: "notification-request-button",
                    on: { click: _vm.enableNotifications },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.showNotificationGuide")) +
                        "\n            "
                    ),
                  ]
                ),
          ]
        ),
        _vm._v(" "),
        _vm.deniedMode
          ? _c("div", { staticClass: "notification-request-close" }, [
              _c(
                "button",
                {
                  staticClass: "notification-request-close-button",
                  on: { click: _vm.closeNotification },
                },
                [
                  _c(
                    "md-icon",
                    {
                      staticClass: "notification-request-icon",
                      staticStyle: { color: "#ffffff" },
                    },
                    [_vm._v("close")]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a-modal",
          {
            attrs: {
              visible: _vm.showNotificationEnableGuidModal,
              centered: "",
              title: _vm.$t("message.howToEnableNotification"),
              cancelText: _vm.$t("message.notificationCancel"),
              okText: _vm.$t("message.notificationOK"),
            },
            on: {
              cancel: function () {
                return (_vm.showNotificationEnableGuidModal = false)
              },
              ok: function () {
                return (_vm.showNotificationEnableGuidModal = false)
              },
            },
          },
          [
            _c("div", [
              _c(
                "p",
                [
                  _c("a-icon", { attrs: { type: "lock" } }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t("message.howToEnableNotificationInstruction1")
                      ) +
                      "\n                "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                [
                  _c("a-icon", { attrs: { type: "notification" } }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t("message.howToEnableNotificationInstruction2")
                      ) +
                      "\n                "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                [
                  _c("a-icon", { attrs: { type: "setting" } }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t("message.howToEnableNotificationInstruction3")
                      ) +
                      "\n                "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                [
                  _c("a-icon", { attrs: { type: "notification" } }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t("message.howToEnableNotificationInstruction4")
                      ) +
                      "\n                "
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }